<template>
  <section class="resources">
    <div container>
      <div grid="row wrap">
        <div column="12">
          <hr class="_mbs" v-if="index > 0">
          <div class="content-wrap _mbs">
            <h2>{{downloadCategory.invoiceDescription}}</h2>
            <a tabindex="0" @click.prevent="showAll = !showAll" v-if="downloadCategory.files.length > 4">
              <span v-if="!showAll">VIEW ALL</span>
              <span v-else>VIEW FEWER</span>
            </a>
          </div>
        </div>
        <div column="xs-12 s-12 m-6" v-for="(resource, i) in resourcesToShow" :key="i">
          <file-download
            @click="handleFileDownload({
              reportId: invoice.invoiceNumber,
              type: 'IN',
              fileName: resource.invoiceFileName,
              invoiceType: resource.invoiceType,
              downloadKey: resource.invoiceFileName,
            })"
            :file-name="resource.invoiceFileName"
            :file-downloading="reportIsDownloading(resource.invoiceFileName)"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import ellipse from '@mixins/ellipse'
  import FileDownload from '@organisms/FileDownload'
  import { useReporting } from '@composables/useReporting'

  export default {
    mixins: [
      ellipse
    ],
    props: {
      invoice: Object,
      downloadCategory: Object,
      index: Number
    },
    components: {
      FileDownload
    },
    data() {
      return { showAll: false }
    },
    computed: {
      resourcesToShow() {
        if (this.showAll) {
          return this.downloadCategory.files
        } else {
          return this.downloadCategory.files.slice(0, 8)
        }
      }
    },
    setup() {
      const { handleFileDownload, reportIsDownloading } = useReporting()
      return {
        handleFileDownload, reportIsDownloading
      }
    }
  }
</script>
<style scoped>
section.resources {
  padding-bottom: 1rem;
  padding-top: 2rem;
}
</style>
